import { forwardRef } from "react";
import { FormControl, FormErrorMessage, Switch } from "@chakra-ui/react";
import { getObjValueFromPath } from "utils";
import { Controller } from "react-hook-form";

function FormSwitch(
  { label, title, isDisabled, name, id = name, errors, control, controlProps, styleProps }, ref
) {
  const error = getObjValueFromPath(name, errors);
  return (
    <FormControl
      isInvalid={error}
      maxInlineSize={{ base: "full", lg: "lg" }}
      minInlineSize="0"
      {...controlProps}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        render={({ field: { value, ...field } }) => (
          <Switch
            ref={ref}
            {...field}
            {...styleProps}
            isChecked={!!value}
            isDisabled={isDisabled}
            title={title ?? ""}
          >
            {label}
          </Switch>
        )}
      />
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default forwardRef(FormSwitch);
